<template>
  <div
    v-if="messages.length"
    class="fixed left-0 top-0 z-[9999999] grid w-full gap-24 p-24"
  >
    <div
      v-for="(message, i) in messages"
      :key="i"
      class="group flex w-full items-center justify-between rounded border p-24 font-semibold tracking-wide shadow-lg md:text-lg"
      :class="classes[message.type]"
    >
      <div class="[&_a]:underline" v-html="message.message" />
      <button
        type="button"
        class="rounded-full bg-white/15 p-4 group-hover:bg-white/70 group-hover:text-gray-800"
        aria-label="Close message"
        @click="removeMessage(i)"
      >
        <SpriteSymbol name="close" class="size-24 fill-current" />
      </button>
    </div>
  </div>
</template>

<script lang="ts" setup>
import type { DrupalMessageType } from '~/composables/useDrupalMessages'

const { messages, removeMessage } = useDrupalMessages()

const classes: Record<DrupalMessageType, string> = {
  error: 'text-white bg-red-500 border-red-200',
  warning: 'text-blue-100 bg-blue-800 border-blue-300',
  status: 'text-white bg-lime-600 border-lime-300',
}
</script>
